export default __webpack_public_path__ + "static/media/password.4de0bb91.svg";